import React from 'react';
// import styled from "styled-components";

/*
 *  @Description:   Stateless component that renders an Download Icon.
 */

const Versions = ( props ) => {

    return (<g id="id" transform="translate(0,6)">
            <path
                d="m 21.88007,-2.9067611 h -9.760141 c -0.894678,0 -1.62669,0.7656083 -1.62669,1.701352 V 12.405408 c 0,0.935744 0.732012,1.701353 1.62669,1.701353 h 9.760141 c 0.89468,0 1.626691,-0.765609 1.626691,-1.701353 V -1.2054091 c 0,-0.9357437 -0.732011,-1.701352 -1.626691,-1.701352 z"/>
            <path
                d="M 3,1.0921586 H 1.1453477 c -0.36282523,0 -0.65318884,0.3075519 -0.65318884,0.6918598 v 7.6319651 c 0,0.3843064 0.29036361,0.6918575 0.65318884,0.6918575 H 3"/>
            <path
                d="M 8,-0.4013513 H 6.1501477 c -0.3618875,0 -0.6514992,0.4094488 -0.6514992,0.921082 V 10.680271 c 0,0.51163 0.2896117,0.92108 0.6514992,0.92108 H 8"/>
        </g>


    )
};

export default Versions;
